/* eslint-disable jsx-a11y/anchor-has-content */
import * as React from 'react';

import '../styles/App.css';
import Footer from '../components/footer/footer';
import Header from '../components/header/header';
import Navbar from '../components/navbar/navbar';
import _gConstants from '../configuration/constants.json';

function Error() {
  document.title=_gConstants.ERROR_PAGE_TITLE;
  return (
    <div>
      <Navbar/>
      <Header status={_gConstants.ERROR_BANNER_STATUS}/>
      <div className="content">
        <div className="text-width">
          <span className="h1">Das hat leider nicht geklappt</span>
          <p className="text error">
          Deine Eingabe wurde leider nicht gespeichert. Entschuldige bitte, unser Fehler. Versuch es bitte später nochmal.<br/><br/>
          Schau Dich doch solange in unserem <a href='https://www.vodafone.de/index.html' target='_parent'>Shop</a> um. Oder logg Dich in Dein MeinVodafone-Konto ein:
          </p>
          <div className="button-container">
            <a
              href="https://www.unitymedia.de/benutzerkonto/login/zugangsdaten"
              target="_self"
              className="btn"
            >
              Zu MeinVodafone
            </a>
          </div>
        </div>
        <div className="division"></div>
      </div>
      <Footer/>
    </div>
  );
}

export default Error;
